import { ref, onBeforeMount, onBeforeUnmount } from "vue";
import { client } from '@UTILS/client';
import {browser} from '@ywxk/util/browser';

// 自定义isShowPage状态
export default function () {
  const isShowPage = ref(true);

  // 切换应用或者主界面(按需保留)
  const _visibilityChange = (function () {
    let hidden;
    if (typeof document.hidden !== "undefined") {
      // Opera 12.10 and Firefox 18 and later support
      hidden = "hidden";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
    }
    return function () {
      // ios最新浏览器返回页面一瞬间网络异常,延长时间试试
      !client.isApp && browser.isSafari ? setTimeout(() => {
        isShowPage.value = !document[hidden];
      }, 100) : (isShowPage.value = !document[hidden])
    };
  })();

  onBeforeMount(() => {
    document.addEventListener("visibilitychange", _visibilityChange, false);
    window.addEventListener("pageshow", _visibilityChange, false);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("visibilitychange", _visibilityChange, false);
    window.removeEventListener("pageshow", _visibilityChange);
  });

  return {
    isShowPage,
  };
}
